import { useSelector } from "react-redux";
import { useTheme } from "styled-components";
import {
  selectFormattedPortfolioHistoryGraphData,
  selectPortfolioHistoryGraphPrecision,
} from "@shared/slices/portfolio.slice";
import AccountChart from "common/Charts/LineChart/AccountChart";
import { portfolioFilters } from "@shared/slices/filters.slice";
import { sharedLib } from "@shared/services/shared.service";
import React, { useMemo } from "react";
import NewLookPortfolioChange from "features/portfolio/NewLook/NewLookPortfolioChange.tsx";

const PortfolioLineChart = () => {
  const { isNewLook } = useTheme();
  if (isNewLook) return <NewLookPortfolioChange />;
  return <ClassicPortfolioLineChart />;
};

const ClassicPortfolioLineChart = () => {
  const selectedTimeRange = useSelector(
    portfolioFilters.selectors.selectTimeRangeFilter
  );
  const { isFetching, isSuccess } =
    sharedLib.sharedApi.portfolio.useGetAmountsHistoryQuery({
      time_range: selectedTimeRange,
    });
  const data = useSelector(selectFormattedPortfolioHistoryGraphData);

  const filters = useMemo(() => {
    return {
      selectors: portfolioFilters.selectors,
      actions: portfolioFilters.actions,
    };
  }, []);

  return (
    <AccountChart
      filters={filters}
      loading={isFetching}
      data={data}
      precisionSelector={selectPortfolioHistoryGraphPrecision}
      isSuccess={isSuccess}
    />
  );
};

export default React.memo(PortfolioLineChart);
